const labOrdenDigitalInitialState = {
  labOrdenDigital: {
    loading: false,
    error: null,
    data: null,
    altaTurno: null,
    load: false,
    pdf: null,
    flgVolver: false,
    medicoOrigSolicitante: null,
    fechaOrden: null,
  },
};

export default labOrdenDigitalInitialState;
